import React from "react";
import { Box, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  buildEmployeeActivityTrail,
  formatActivityTrailAt,
  getActivityTrailInitials,
} from "./ActivityTrailModal";
import "./RejectionCommentModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 440,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  outline: "none",
  overflow: "hidden",
};

/**
 * Newest INVITE_REJECTED trail entry that has a reason, else null.
 */
export const buildRejectionComment = (row) => {
  const entries = buildEmployeeActivityTrail(row);
  const reject = entries.find(
    (entry) =>
      entry.status === "INVITE_REJECTED" && String(entry.comment || "").trim()
  );
  if (!reject) return null;
  return {
    actorName: reject.actorName || "—",
    initials: reject.initials || getActivityTrailInitials(reject.actorName),
    at: reject.at,
    comment: String(reject.comment).trim(),
  };
};

export const employeeHasRejectionComment = (row) =>
  Boolean(buildRejectionComment(row));

export const RejectionCommentModal = ({ open, onClose, comment = null }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="rejection-comment-title"
    >
      <Box sx={modalStyle} className="rejection-comment-modal">
        <header className="rejection-comment-modal__header">
          <h2 id="rejection-comment-title">Comment</h2>
          <button
            type="button"
            className="rejection-comment-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </button>
        </header>

        <div className="rejection-comment-modal__body">
          {comment ? (
            <>
              <div className="rejection-comment-modal__actor">
                <span
                  className="rejection-comment-modal__avatar"
                  aria-hidden
                >
                  {comment.initials}
                </span>
                <div className="rejection-comment-modal__actor-meta">
                  <span className="rejection-comment-modal__name">
                    {comment.actorName}
                  </span>
                  <span className="rejection-comment-modal__time">
                    {formatActivityTrailAt(comment.at)}
                  </span>
                </div>
              </div>
              <div className="rejection-comment-modal__comment">
                {comment.comment}
              </div>
            </>
          ) : (
            <p className="rejection-comment-modal__empty">
              No rejection comment available.
            </p>
          )}
        </div>
      </Box>
    </Modal>
  );
};
